import { Component, EventEmitter, Input, Output, ViewChildren, QueryList } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchboxComponent } from "src/ui/components/searchbox/searchbox.component";
import { DropdownSimpleComponent } from "src/ui/components/dropdowns/simple/dropdown-simple.component";
import { ButtonsComponent } from "src/ui/components/buttons/buttons.component";
import { DropdownOption } from 'src/ui/interfaces/dropdown.interfaces';

@Component({
  selector: 'app-table-header',
  standalone: true,
  imports: [CommonModule, SearchboxComponent, DropdownSimpleComponent, ButtonsComponent],
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
})
export class TableHeaderComponent {
  @Input() showSearch = false;
  @Input() showFilters = false;
  @Input() showCreateButton = false;
  @Input() filterOptions: { [key: string]: DropdownOption[] } = {};
  @Input() filterLabels: { [key: string]: string } = {};
  @Input() createButtonText = 'Crear';
  @Input() createButtonIcon = 'fi fi-br-plus';
  @Input() filters: { [key: string]: string | null } = {};

  @Output() searchChange = new EventEmitter<string>();
  @Output() filterChange = new EventEmitter<{ [key: string]: string | null }>();
  @Output() clearFiltersClick = new EventEmitter<void>();
  @Output() createClick = new EventEmitter<void>();

  showMobileFilters = false;
  appliedFilters: { [key: string]: string | null } = {};
  objectKeys = Object.keys;

  // 👇 Aquí es lo que te faltaba
  @ViewChildren(DropdownSimpleComponent) dropdowns!: QueryList<DropdownSimpleComponent>;

  ngOnInit(): void {
    this.appliedFilters = { ...this.filters };
  }

  clearFilters() {
    // limpiar estado interno
    Object.keys(this.appliedFilters).forEach(key => {
      this.appliedFilters[key] = null;
    });
    this.filterChange.emit({ ...this.appliedFilters });
    this.clearFiltersClick.emit();

    // reset visual de todos los dropdowns
    this.dropdowns.forEach(d => d.reset());
  }

  onFilterChange(key: string, value: string) {
    this.appliedFilters = {
      ...this.appliedFilters,
      [key]: value || null
    };
    this.filterChange.emit({ ...this.appliedFilters });
  }

  onCrearProducto() {
    this.createClick.emit();
  }

  toggleMobileFilters() {
    this.showMobileFilters = !this.showMobileFilters;
  }

  hasActiveFilters(): boolean {
    return Object.values(this.appliedFilters).some(value => value !== null && value !== '');
  }
}
